var CatalogCtrl = function () {};
export default CatalogCtrl;